import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './components/HomePage';
import AIUseWizard from './components/AIUseWizard';
import AIKnowledgeWizard from './components/AIKnowledgeWizard';
import TeamsToSalesforceWithAuth from './components/TeamsToSalesforce';
import ProtectedStaticPage from './components/ProtectedStaticPage';
import NavBar from './components/NavBar';
import GPTfyBarista from './components/GPTfyBarista';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import manifestData from './config/manifest.json';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/" />;
  }

  return (
    <>
      <NavBar />
      <div style={{ paddingTop: '36px' }}>{children}</div>
    </>
  );
};

const AuthenticatedExtras = () => {
  const { user } = useAuth();
  return user ? <GPTfyBarista /> : null;
};

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/wizard"
            element={
              <ProtectedRoute>
                <AIUseWizard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/knowledge-import"
            element={
              <ProtectedRoute>
                <AIKnowledgeWizard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/teams-salesforce"
            element={
              <ProtectedRoute>
                <TeamsToSalesforceWithAuth />
              </ProtectedRoute>
            }
          />
          {/* Content pages — routes driven by manifest.json, no code changes needed */}
          {manifestData.pages
            .filter(p => p.contentType !== 'component' && p.route)
            .map(page => (
              <Route
                key={page.slug}
                path={page.route}
                element={<ProtectedStaticPage slug={page.slug} />}
              />
            ))
          }
        </Routes>
        <AuthenticatedExtras />
      </Router>
    </AuthProvider>
  );
};

export default App;
